import script from "./PwaFinance.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaFinance.vue?vue&type=script&setup=true&lang=ts"

import "./PwaFinance.vue?vue&type=style&index=0&id=78b6389f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b6389f"]])

export default __exports__